<template>
  <div class="info-row-button" @click="click">
    <img 
      v-if="logo != null" 
      class="logo" 
      :class="clase" 
      :src="logo" alt=""
    >
    <div v-else class="vendor">
      <img class="icon" :src="icon" alt="">
      <div class="method">{{ method }}</div>
    </div>
    <div class="flexImgs"  v-if="cardsCheck">
      <img :src="imgCard" alt="" class="idCheck">
      <img src="/assets/images/visaCard.svg" alt="" class="visa">
    </div>
    <div class="processing" v-if="processing !== 'null' ">{{ processing }}</div>
    <div v-if="region !== 'mena'" class="fee">{{ fee }}</div>
    <div class="arrow-right"></div>
  </div>
</template>

<script>
import store from "@/store";
import { ref } from "@vue/runtime-core";
export default {
  name: "InfoRowButton",
  props: {
    icon: String,
    method: String,
    logo: String,
    processing: String,
    fee: String,
    cardsCheck: {
      type: Boolean,
      default: false
    },
    clase: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      imgCard: ''
    }
  },
  setup() {
    let region = ref(process.env.VUE_APP_CABINET_ORIGIN);
    return {
      region,
    };
  },
  mounted(){
    this.imgSite()

    console.log(this.logo)
    console.log(this.clase)
  },
  methods: {
    click() {
      this.$emit('click')
    },
    imgSite(){
      let theme = store.state.preferences.theme
      if (theme == 'LIGHT') {
        this.imgCard = '/assets/images/logoTarjeta.svg'
      }
      if (theme == 'DARK') {
        this.imgCard = '/assets/images/logo-mc-idsecure.svg'
      }
    }
  }
}
</script>
